import {combineReducers} from 'redux';
import { routerReducer } from 'react-router-redux';
import artists from './artistReducer';
import tracks from './trackReducer';
import videos from './videoReducer';
import account from './accountReducer';
import gigs from './gigReducer';
import genres from './genreReducer';
import instruments from './instrumentReducer';
import blog from './blogReducer';
import activity from './activityReducer';
import location from './locationReducer';
import discussions from './discussionReducer';
import modal from './modalReducer';

//we use artists instead of artistReducer here so we can say state.artists which makes sense
const rootReducer = combineReducers({
    artists,
    tracks,
    videos,
    account,
    gigs,
    genres,
    instruments,
    blog,
    activity,
    location,
    discussions,
    modal,
    routing: routerReducer
});

export default rootReducer;
